// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3kGcT","title":"ClientReferral_title__24SKv","itemText":"ClientReferral_itemText__54iIP"};